import { render, staticRenderFns } from "./TicketView.vue?vue&type=template&id=2844056a&"
import script from "./TicketView.vue?vue&type=script&lang=js&"
export * from "./TicketView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2844056a')) {
      api.createRecord('2844056a', component.options)
    } else {
      api.reload('2844056a', component.options)
    }
    module.hot.accept("./TicketView.vue?vue&type=template&id=2844056a&", function () {
      api.rerender('2844056a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/TicketView.vue"
export default component.exports